
































import Vue from 'vue'
import TitleName from '../atoms/TitleName.vue'
import FaqForTensakuVisiter from '../../utils/FaqForTensakuVisiter'

interface Question {
  id: number
  text: string
}

interface listItem {
  name: string
  refName: string
  questions: Array<Question>
}

export type DataType = {
  titleName: string
  showContent: boolean
  showSubmit: boolean
  showImage: boolean
  showImagePath: string | null
  width: number | null
  examId: string | null
  lists: Array<listItem>
}

export default Vue.extend({
  components: {
    TitleName,
  },
  data(): DataType {
    return {
      titleName: 'よくある質問',
      showContent: false,
      showSubmit: false,
      showImage: false,
      showImagePath: null,
      width: null,
      examId: null,
      lists: [
        {
          name: 'テストの提出',
          refName: '#cate02',
          questions: []
        },
        {
          name: 'テストの返却',
          refName: '#cate03',
          questions: []
        },
        {
          name: 'ログイン情報',
          refName: '#cate04',
          questions: []
        }
      ],
    }
  },
  created() {
    this.$store.commit('SET_EXAM_INFO', { examInfo: null })
    const examKey = this.$route.params['exam_id']
    if (Object.keys(FaqForTensakuVisiter).includes(examKey)) {
      FaqForTensakuVisiter[examKey].forEach((faq) => {
        this.lists.find((listItem) => listItem.refName === faq.code)
          ?.questions.push({id: faq.id, text: faq.question})
      })
      this.examId = examKey
    } else {
      this.lists = []
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    if (!this.$route.hash) return
    this.$nextTick(() => {
      this.scrollToCategory(this.$route.hash)
    })
  },
  watch: {
    "$route.hash"(newValue) {
      this.$nextTick(() => {
        this.scrollToCategory(newValue)
      })
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  computed:{
    displayForMember(): boolean {
      return this.$store.state.displayForMember
    },
    envCheckUrl() {
      return `${process.env.VUE_APP_ROOT_PATH}/participant/device/`
    }
  },
  methods: {
    handleResize(): void {
      this.width = window.innerWidth;
    },
    openModal(): void {
      this.showSubmit = true
    },
    closeModal(): void {
      this.showSubmit = false
    },
    openImageModal(path: string): void {
      this.showImagePath = path
      this.showImage = true
    },
    closeImageModal(): void {
      this.showImagePath = null
      this.showImage = false
    },
    moveTakePicturePage(): void {
      this.$router.push('/photograph_not_member')
    },
    scrollToCategory(refName: string): void {
      const ref: any = this.$refs[refName]
      ref[0].scrollIntoView({ behavior: 'smooth' })
    },
  }
})
